/* Product tabs (Sheraz custom section `product-tabs`), extracted from the section's inline script 09/24/2026.
   One cached file for all instances; per-instance config comes from data-pt-config on the .product-tabs root. */
(function() {
    function initProductTabs(navContainer, cfg) {
      
      if (!navContainer) return;
      
      // JC-EVO 10/06/2026 (RC8): retain instance listeners for editor unload cleanup.
      const instanceListeners = [];
      function listen(target, type, handler, options) {
        target.addEventListener(type, handler, options);
        instanceListeners.push(() => target.removeEventListener(type, handler, options));
      }
      const tabs = navContainer.querySelectorAll('.pt-tab');
      if (tabs.length === 0) return;
      
      // Get all class targets from all tabs
    function getAllTargetClasses() {
      const allClasses = [];
      tabs.forEach(tab => {
        const classes = tab.dataset.tabClasses;
        if (classes) {
          classes.split(',').forEach(cls => {
            const trimmed = cls.trim();
            if (trimmed && !allClasses.includes(trimmed)) {
              allClasses.push(trimmed);
            }
          });
        }
      });
      return allClasses;
    }
    
    // Check if an element is hidden by CSS rules (not by our tab system)
    // Returns true if the element or its shopify-section parent has display:none from CSS
    function isElementPermanentlyHidden(el) {
      if (!el) return true;
      
      // Check the shopify-section wrapper - if it's hidden, the content is hidden
      const shopifySection = el.closest('.shopify-section');
      if (shopifySection) {
        const style = window.getComputedStyle(shopifySection);
        if (style.display === 'none') {
          return true;
        }
      }
      
      // Check if element itself has display:none !important (from inline style tag)
      // This is how our sections hide themselves when they have no data
      const inlineStyle = el.getAttribute('style') || '';
      if (inlineStyle.includes('display: none !important') || inlineStyle.includes('display:none !important')) {
        return true;
      }
      
      // Check computed style, but IGNORE our tab system's hiding
      // Our tab system uses the .pt-tab-content class, so if element has that class,
      // we need to check if it's hidden for OTHER reasons
      if (el.classList.contains('pt-tab-content')) {
        // Element is managed by our tab system - check if it would be visible when active
        // Temporarily check without our hiding class
        const wasHidden = !el.classList.contains('is-visible');
        if (wasHidden) {
          el.classList.add('is-visible');
        }
        const style = window.getComputedStyle(el);
        const isHidden = style.display === 'none';
        if (wasHidden) {
          el.classList.remove('is-visible');
        }
        
        // Even if element is visible, check if it has any visible accordion/tab content
        if (!isHidden) {
          const hasVisibleContent = hasVisibleChildContent(el);
          if (!hasVisibleContent) {
            return true;
          }
        }
        
        return isHidden;
      }
      
      // For elements not yet managed by our tab system
      const style = window.getComputedStyle(el);
      if (style.display === 'none') {
        return true;
      }
      
      // Check if element has any visible child content (for accordion sections)
      return !hasVisibleChildContent(el);
    }
    
    // Check if an element has any visible child content
    // This handles the case where a section exists but all its accordions are hidden
    function hasVisibleChildContent(el) {
      if (!el) return false;
      
      // Look for accordion items (details elements with ptc__tab class or similar)
      const accordionItems = el.querySelectorAll('.ptc__tab, details[class*="tab-name-"], .accordion__item, .collapsible-tab');
      
      // If there are accordion items, check if at least one is visible
      if (accordionItems.length > 0) {
        for (const item of accordionItems) {
          const style = window.getComputedStyle(item);
          if (style.display !== 'none') {
            return true;
          }
        }
        // All accordion items are hidden
        return false;
      }
      
      // If no accordion items found, check for any meaningful content
      // Look for common content elements
      const contentElements = el.querySelectorAll('p, h1, h2, h3, h4, h5, h6, img, table, ul, ol, .content, .description');
      if (contentElements.length > 0) {
        for (const content of contentElements) {
          const style = window.getComputedStyle(content);
          if (style.display !== 'none' && style.visibility !== 'hidden') {
            // Check if parent chain is visible
            let parent = content.parentElement;
            let isParentVisible = true;
            while (parent && parent !== el) {
              const parentStyle = window.getComputedStyle(parent);
              if (parentStyle.display === 'none') {
                isParentVisible = false;
                break;
              }
              parent = parent.parentElement;
            }
            if (isParentVisible) {
              return true;
            }
          }
        }
        return false;
      }
      
      // No specific content found - assume it has content if the element itself is visible
      return true;
    }
    
    // Check if all elements for a tab's target classes are hidden (permanently, not by tab system)
    function areAllTabElementsHidden(targetClasses) {
      if (!targetClasses) return true;
      
      const classes = targetClasses.split(',').map(c => c.trim()).filter(c => c);
      if (classes.length === 0) return true;
      
      let totalElements = 0;
      let hiddenElements = 0;
      
      classes.forEach(cls => {
        const elements = document.querySelectorAll('.' + cls);
        elements.forEach(el => {
          totalElements++;
          if (isElementPermanentlyHidden(el)) {
            hiddenElements++;
          }
        });
      });
      
      // If no elements found with this class, consider the tab as having no content
      if (totalElements === 0) return true;
      
      // Tab should be hidden only if ALL elements are permanently hidden
      return hiddenElements === totalElements;
    }
    
    // Hide tabs that have no visible content
    function updateTabVisibility() {
      let firstVisibleTab = null;
      let activeTabIsVisible = false;

      // JC-EVO 09/28/2026 (speed): reveal every hidden tab panel once, measure all tabs, then restore, all before the next
      // paint. isElementPermanentlyHidden() otherwise switches each hidden panel on and off in turn, forcing one full style
      // recalculation per panel (~60 ms each on a mid-range phone). Same answer: panels are measured revealed either way.
      const revealed = [];
      getAllTargetClasses().forEach(cls => {
        document.querySelectorAll('.' + cls).forEach(el => {
          if (el.classList.contains('pt-tab-content') && !el.classList.contains('is-visible')) {
            el.classList.add('is-visible');
            revealed.push(el);
          }
        });
      });
      let hiddenByTab;
      try {
        hiddenByTab = Array.from(tabs).map(tab => areAllTabElementsHidden(tab.dataset.tabClasses));
      } finally {
        revealed.forEach(el => el.classList.remove('is-visible'));
      }
      
      tabs.forEach((tab, index) => {
        const allHidden = hiddenByTab[index];
        
        if (allHidden) {
          tab.style.display = 'none';
          tab.setAttribute('aria-hidden', 'true');
        } else {
          tab.style.display = '';
          tab.removeAttribute('aria-hidden');
          if (!firstVisibleTab) {
            firstVisibleTab = tab;
          }
          if (tab.classList.contains('is-active')) {
            activeTabIsVisible = true;
          }
        }
      });
      
      // If active tab is now hidden, activate the first visible tab
      if (!activeTabIsVisible && firstVisibleTab) {
        tabs.forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-pressed', 'false');
        });
        firstVisibleTab.classList.add('is-active');
        firstVisibleTab.setAttribute('aria-pressed', 'true');
        showTabContent(firstVisibleTab.dataset.tabClasses);
      }
      
      // Hide the entire section if no tabs are visible
      const visibleTabs = Array.from(tabs).filter(t => t.style.display !== 'none');
      const sectionWrapper = navContainer.closest('.shopify-section');
      const hideWhenEmpty = cfg.hide_when_empty;
      
      // JC-EVO 09/28/2026 (D07, Eric: "Make sure the content is still shown"): a bar with a single tab has nothing to
      // switch, so it is hidden like an empty one. That tab is the active tab (see above), so its content stays visible.
      if (visibleTabs.length < 2) {
        navContainer.style.display = 'none';
        // Also hide the parent shopify-section wrapper if setting is enabled
        if (hideWhenEmpty && sectionWrapper) {
          sectionWrapper.style.display = 'none';
        }
      } else {
        navContainer.style.display = '';
        if (sectionWrapper) {
          sectionWrapper.style.display = '';
        }
      }
    }
    
    // Show elements matching the classes, hide others
    function showTabContent(targetClasses) {
      // JC-EVO 10/07/2026 (RC10): link toggle buttons to every controlled element.
      tabs.forEach((tab, tabIndex) => {
        const ids = [];
        (tab.dataset.tabClasses || '').split(',').forEach(cls => {
          const trimmed = cls.trim();
          if (!trimmed) return;
          document.querySelectorAll('.' + trimmed).forEach(el => {
            if (!el.id) {
              let n = ids.length;
              let id = 'jc-pt-' + tabIndex + '-' + n;
              while (document.getElementById(id)) id = 'jc-pt-' + tabIndex + '-' + (++n);
              el.id = id;
            }
            if (!ids.includes(el.id)) ids.push(el.id);
          });
        });
        tab.setAttribute('aria-controls', ids.join(' '));
      });
      const allClasses = getAllTargetClasses();
      
      // Hide all tab content elements
      allClasses.forEach(cls => {
        const elements = document.querySelectorAll('.' + cls);
        elements.forEach(el => {
          el.classList.add('pt-tab-content');
          el.classList.remove('is-visible');
        });
      });
      
      // Show elements matching target classes
      if (targetClasses) {
        targetClasses.split(',').forEach(cls => {
          const trimmed = cls.trim();
          if (trimmed) {
            const elements = document.querySelectorAll('.' + trimmed);
            elements.forEach(el => {
              el.classList.add('pt-tab-content');
              el.classList.add('is-visible');
            });
          }
        });
      }
    }
    
    // Initialize - show first tab's content first, then check visibility
    const firstTab = tabs[0];
    if (firstTab) {
      showTabContent(firstTab.dataset.tabClasses);
    }
    
    // Mark as initialized to let JS take over visibility control
    // CSS uses body class to hide non-first-tab content before JS runs
    navContainer.classList.add('is-initialized');
    document.body.classList.add('pt-tabs-initialized-' + cfg.secId);
    
    // Use delays to let other sections render their hide styles, then update visibility
    // Run multiple times to catch late-rendering content
    setTimeout(() => {
      if (navContainer.isConnected) updateTabVisibility(); // JC-EVO 10/06/2026 (RC8): detached callback.
    }, 150);
    
    setTimeout(() => {
      if (navContainer.isConnected) updateTabVisibility(); // JC-EVO 10/06/2026 (RC8): detached callback.
    }, 500);
    
    // Final check after page is fully loaded
    listen(window, 'load', () => {
      setTimeout(() => {
        if (navContainer.isConnected) updateTabVisibility(); // JC-EVO 10/06/2026 (RC8): detached callback.
      }, 100);
    });
    
    // Tab click handlers
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        // JC-EVO 10/06/2026 (RC8): cancel even a pending measurement before switching tabs.
        endTabScroll();
        // Update active tab
        tabs.forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-pressed', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-pressed', 'true');
        
        // Show/hide content
        showTabContent(tab.dataset.tabClasses);
        
        // Scroll to content if user has scrolled past it
        scrollToTabContent(tab.dataset.tabClasses);
        
        // Scroll tab into view on mobile
        if (window.innerWidth < 750) {
          tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    });
    
    // Scroll to the first content element of the active tab
    const scrollToContentEnabled = cfg.scroll_to_content;
    const scrollExtraOffset = cfg.scroll_offset;

    // Spacer used to guarantee the page is tall enough to scroll a SHORT tab's
    // content up to just below the nav. Without it, switching from a tall tab to
    // a short one leaves the browser clamped at the bottom of the document, so
    // the new content never reaches the top of the viewport.
    let scrollSpacer = null;

    function getScrollSpacer() {
      if (!scrollSpacer || !scrollSpacer.isConnected) {
        scrollSpacer = document.createElement('div');
        scrollSpacer.className = 'pt-scroll-spacer';
        scrollSpacer.setAttribute('aria-hidden', 'true');
        scrollSpacer.style.cssText = 'height:0;width:100%;flex-shrink:0;pointer-events:none;';
      }
      return scrollSpacer;
    }

    function positionScrollSpacer(lastContentElement) {
      const spacer = getScrollSpacer();
      const anchor = lastContentElement.closest('.shopify-section') || lastContentElement;
      if (anchor.parentNode && spacer.previousElementSibling !== anchor) {
        anchor.parentNode.insertBefore(spacer, anchor.nextSibling);
      }
      return spacer;
    }

    function resetScrollSpacer() {
      if (scrollSpacer) scrollSpacer.style.height = '0px';
    }

    // All currently visible content elements for a tab, in document order
    function getVisibleContentElements(targetClasses) {
      const classes = (targetClasses || '').split(',').map(c => c.trim()).filter(c => c);
      const found = [];
      classes.forEach(cls => {
        document.querySelectorAll('.' + cls).forEach(el => {
          if (el.classList.contains('is-visible') && !isElementPermanentlyHidden(el)) {
            found.push(el);
          }
        });
      });
      found.sort((a, b) => {
        const pos = a.compareDocumentPosition(b);
        if (pos & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
        if (pos & Node.DOCUMENT_POSITION_PRECEDING) return 1;
        return 0;
      });
      return found;
    }

    // --- Horizon 4 scroll-container shim -------------------------------------
    // Horizon 4 scrolls .page-wrapper instead of the document on desktop
    // (base.css sets html/body to overflow:hidden above 990px), so window.scrollY,
    // window.scrollTo and window scroll events are all inert there. Resolve the
    // real scroller at call time, because it changes with viewport width.
    function getScroller() {
      const wrapper = document.querySelector('.page-wrapper');
      if (wrapper && getComputedStyle(wrapper).overflowY === 'auto') return wrapper;
      return document.scrollingElement || document.documentElement;
    }

    function getScrollTop() {
      return getScroller().scrollTop;
    }

    function getScrollMax() {
      const scroller = getScroller();
      return Math.max(0, scroller.scrollHeight - scroller.clientHeight);
    }

    function scrollToY(top, behavior) {
      getScroller().scrollTo({ top: top, behavior: behavior || 'auto' });
    }

    // Bind to both targets: which one actually scrolls depends on viewport width
    // and can change on resize. The handler is idempotent, so double-firing is fine.
    function onScroll(handler) {
      listen(window, 'scroll', handler, { passive: true });
      const wrapper = document.querySelector('.page-wrapper');
      if (wrapper) listen(wrapper, 'scroll', handler, { passive: true });
    }
    // -------------------------------------------------------------------------

    // Space the content top should sit below the viewport top
    function getScrollOffset() {
      const stickyOffset = cfg.sticky_offset;
      const stickyOffsetMobile = cfg.sticky_offset_mobile;
      let currentOffset = window.innerWidth < 750 ? stickyOffsetMobile : stickyOffset;
      // JC-EVO 10/06/2026 (RC8): use the tab bar's real sticky top. jc-live-bar.css moves it while the live bar is open or the phone
      // header hides; the configured offset alone landed the content under the bar and jc-live-bar.js then snapped the page.
      const stickyWrapper = navContainer.closest('.shopify-section');
      if (cfg.sticky_nav && stickyWrapper && !stickyWrapper.classList.contains('sticky-disabled')) {
        const stickyTop = window.getComputedStyle(stickyWrapper).top;
        const parsedTop = parseFloat(stickyTop);
        if (/^-?(?:\d+\.?\d*|\.\d+)px$/.test(stickyTop) && Number.isFinite(parsedTop)) {
          currentOffset = parsedTop;
        }
      }
      return navContainer.offsetHeight + currentOffset + scrollExtraOffset;
    }

    // JC-EVO 10/06/2026 (RC8): measure the unextended extent without collapsing/clamping.
    function fitScrollSpacer(targetY, preservePosition) {
      const height = scrollSpacer.getBoundingClientRect().height;
      const unextendedMax = getScrollMax() - height;
      const deficit = Math.max(0, Math.ceil(targetY - unextendedMax));
      const currentNeed = Math.max(0, Math.ceil(getScrollTop() - unextendedMax));
      // JC-EVO 10/06/2026 (RC8): shrink only when the current position remains valid.
      scrollSpacer.style.height = ((preservePosition || currentNeed > deficit)
        ? Math.max(deficit, currentNeed) : deficit) + 'px';
    }

    function sizeScrollSpacer(firstEl, lastEl, totalOffset = getScrollOffset()) {
      positionScrollSpacer(lastEl);
      const contentTop = firstEl.getBoundingClientRect().top;
      const targetY = Math.max(0, getScrollTop() + contentTop - totalOffset);
      fitScrollSpacer(targetY, true); // JC-EVO 10/06/2026 (RC8): includes initial/repeated clicks and resize.
      return { targetY: targetY, contentTop: contentTop, totalOffset: totalOffset };
    }

    // JC-EVO 10/06/2026 (RC8): retarget only during a bounded tab scroll; use a readable top destination immediately.
    let tabScroll = null;
    let tabScrollDelay = null;
    const tabScrollWrapper = navContainer.closest('.shopify-section');

    // JC-EVO 10/06/2026 (RC8): destination clearance beats the live bar's 180 ms settle.
    function topTransition() {
      return tabScrollWrapper && tabScrollWrapper.getAnimations &&
        tabScrollWrapper.getAnimations().find(animation =>
          typeof CSSTransition !== 'undefined' && animation instanceof CSSTransition &&
          animation.transitionProperty === 'top' &&
          (animation.playState === 'running' || animation.playState === 'pending'));
    }

    function transitionOffset(animation) {
      if (!cfg.sticky_nav || tabScrollWrapper.classList.contains('sticky-disabled')) return null;
      try {
        const frames = animation.effect.getKeyframes();
        const top = frames[frames.length - 1].top;
        if (/^-?(?:\d+\.?\d*|\.\d+)px$/.test(top) && Number.isFinite(parseFloat(top))) {
          return navContainer.offsetHeight + parseFloat(top) + scrollExtraOffset;
        }
      } catch (e) { /* JC-EVO 10/06/2026 (RC8): unreadable effects retain round-2 waiting. */ }
      return null;
    }

    function endTabScroll() {
      clearTimeout(tabScrollDelay);
      tabScrollDelay = null;
      if (!tabScroll) return;
      cancelAnimationFrame(tabScroll.frame);
      clearTimeout(tabScroll.idle);
      clearTimeout(tabScroll.noScroll);
      clearTimeout(tabScroll.expiry);
      tabScroll.endTarget.removeEventListener('scrollend', settleTabScroll);
      ['wheel', 'touchstart', 'keydown'].forEach(type =>
        window.removeEventListener(type, endTabScroll, true));
      const targetY = tabScroll.targetY; // JC-EVO 10/06/2026 (RC8): trim safe excess after the session.
      tabScroll = null;
      if (navContainer.isConnected && scrollSpacer && scrollSpacer.isConnected) fitScrollSpacer(targetY, false);
    }

    function bindTabScrollEnd() {
      const scroller = getScroller();
      // Document scrolling emits scrollend on Document; element scrolling emits it on the element.
      const target = scroller === document.scrollingElement || scroller === document.documentElement
        ? document : scroller;
      if (tabScroll.endTarget === target) return;
      if (tabScroll.endTarget) {
        tabScroll.endTarget.removeEventListener('scrollend', settleTabScroll);
        // JC-EVO 10/06/2026 (RC8): the new scroller may never emit an end event for the old motion.
        tabScroll.settling = true;
      }
      tabScroll.endTarget = target;
      tabScroll.hasScrollEnd = 'onscrollend' in target;
      if (tabScroll.hasScrollEnd) target.addEventListener('scrollend', settleTabScroll);
    }

    function retargetTabScroll(elements, offset = getScrollOffset()) {
      const measurements = sizeScrollSpacer(elements[0], elements[elements.length - 1], offset);
      tabScroll.targetY = measurements.targetY; // JC-EVO 10/06/2026 (RC8): retain the latest spacer target.
      tabScroll.offset = measurements.totalOffset;
      tabScroll.settling = false;
      clearTimeout(tabScroll.idle);
      clearTimeout(tabScroll.noScroll);
      // Also cover a clamped/no-op scroll: no scrollend is guaranteed when nothing moves.
      tabScroll.noScroll = setTimeout(settleTabScroll, 200);
      scrollToY(measurements.targetY, 'smooth');
    }

    function settleTabScroll() {
      if (!navContainer.isConnected) { endTabScroll(); return; } // JC-EVO 10/06/2026 (RC8): detached instance.
      if (!tabScroll) return;
      tabScroll.settling = true;
      if (topTransition()) return; // The session's rAF checks again when it finishes/cancels.
      const elements = getVisibleContentElements(tabScroll.classes);
      if (!elements.length || tabScroll.corrections >= 2 ||
          Math.abs(elements[0].getBoundingClientRect().top - getScrollOffset()) <= 2) {
        endTabScroll();
        return;
      }
      tabScroll.corrections++;
      retargetTabScroll(elements);
    }

    function tabScrollFrame() {
      if (!navContainer.isConnected) { endTabScroll(); return; } // JC-EVO 10/06/2026 (RC8): detached frame.
      if (!tabScroll) return;
      if (Date.now() >= tabScroll.endTime) {
        endTabScroll();
        return;
      }
      bindTabScrollEnd(); // Width changes can switch Horizon's active scroller.
      // JC-EVO 10/06/2026 (RC8): retarget once to a readable destination, then check final geometry.
      const transition = topTransition();
      const offset = transition ? transitionOffset(transition) : getScrollOffset();
      if (tabScroll.settling && !transition) {
        settleTabScroll();
      } else if (offset !== null && Math.abs(offset - tabScroll.offset) > 1) {
        const elements = getVisibleContentElements(tabScroll.classes);
        if (!elements.length) {
          endTabScroll();
          return;
        }
        retargetTabScroll(elements, offset);
      }
      if (tabScroll) tabScroll.frame = requestAnimationFrame(tabScrollFrame);
    }

    onScroll(event => {
      if (!navContainer.isConnected) { endTabScroll(); return; } // JC-EVO 10/06/2026 (RC8): detached event.
      if (!tabScroll) return;
      // JC-EVO 10/06/2026 (RC8): ignore old-scroller events after a breakpoint transfer.
      const scroller = getScroller();
      const documentScroll = scroller === document.scrollingElement || scroller === document.documentElement;
      if (event.target !== scroller && !(documentScroll &&
          (event.target === document || event.target === window))) return;
      tabScroll.settling = false;
      bindTabScrollEnd();
      clearTimeout(tabScroll.noScroll);
      clearTimeout(tabScroll.idle);
      if (!tabScroll.hasScrollEnd) tabScroll.idle = setTimeout(settleTabScroll, 120);
    });

    function scrollToTabContent(targetClasses) {
      endTabScroll();
      // Check if scroll to content is enabled
      if (!scrollToContentEnabled) return;
      if (!targetClasses) return;

      // Small delay to let content become visible
      tabScrollDelay = setTimeout(() => {
        tabScrollDelay = null;
        if (!navContainer.isConnected) return; // JC-EVO 10/06/2026 (RC8): detached measurement.
        const elements = getVisibleContentElements(targetClasses);
        if (elements.length === 0) {
          resetScrollSpacer();
          return;
        }

        // JC-EVO 10/06/2026 (RC8): a click during a readable transition uses its destination too.
        const transition = topTransition();
        const destination = transition ? transitionOffset(transition) : null;
        const measurements = sizeScrollSpacer(elements[0], elements[elements.length - 1],
          destination === null ? getScrollOffset() : destination);

        // Already sitting exactly under the nav - nothing to do
        if (Math.abs(measurements.contentTop - measurements.totalOffset) <= 2) return;

        tabScroll = { classes: targetClasses, offset: measurements.totalOffset,
          targetY: measurements.targetY, // JC-EVO 10/06/2026 (RC8): safe end-of-session shrink target.
          endTime: Date.now() + 2500, corrections: 0, settling: false };
        bindTabScrollEnd();
        ['wheel', 'touchstart', 'keydown'].forEach(type =>
          window.addEventListener(type, endTabScroll, { passive: true, once: true, capture: true }));
        tabScroll.expiry = setTimeout(endTabScroll, 2500);
        tabScroll.noScroll = setTimeout(settleTabScroll, 200); // 250 ms after the click, including measurement delay.
        tabScroll.frame = requestAnimationFrame(tabScrollFrame);
        scrollToY(measurements.targetY, 'smooth');
      }, 50);
    }

    // JC-EVO 10/06/2026 (RC8): release the old editor instance, including both scroll bindings.
    function cleanupProductTabs() {
      endTabScroll();
      // JC-EVO 10/06/2026 (RC8): editor reload is the only caller; remove this instance's spacer (a clamp here is harmless).
      if (scrollSpacer && scrollSpacer.isConnected) scrollSpacer.remove();
      scrollSpacer = null;
      clearTimeout(spacerResizeTimeout);
      clearTimeout(updateTimeout);
      observer.disconnect();
      instanceListeners.splice(0).forEach(remove => remove());
      document.removeEventListener('shopify:section:unload', unloadProductTabs);
    }

    function unloadProductTabs(event) {
      const sectionId = event.detail && event.detail.sectionId;
      if (event.target === tabScrollWrapper || (tabScrollWrapper &&
          (event.target.id === tabScrollWrapper.id || (sectionId && tabScrollWrapper.id === 'shopify-section-' + sectionId)))) {
        cleanupProductTabs();
      }
    }
    document.addEventListener('shopify:section:unload', unloadProductTabs);

    // Keep the spacer accurate when the viewport changes (rotation, URL bar, resize)
    function refreshScrollSpacer() {
      if (!navContainer.isConnected) return; // JC-EVO 10/06/2026 (RC8): detached resize.
      // JC-EVO 09/29/2026 (Eric: blank gap on a short product page after a resize): only re-size a spacer that a tab click
      // created. Before, any window resize (zoom, window size, dev tools) sized one for the default tab even when nobody had
      // clicked a tab, or the tab bar was hidden, leaving an empty band below the tab content on short pages.
      if (!scrollSpacer || !scrollSpacer.isConnected) return;
      const activeTab = navContainer.querySelector('.pt-tab.is-active');
      if (!activeTab) return;

      const elements = getVisibleContentElements(activeTab.dataset.tabClasses);
      if (elements.length === 0) {
        resetScrollSpacer();
        return;
      }

      const wasAligned = Math.abs(elements[0].getBoundingClientRect().top - getScrollOffset()) <= 2;
      // JC-EVO 10/06/2026 (RC8): resize outside a tab scroll collapses and re-measures exactly as before (aligned position restored right after), trimming interrupted-session excess.
      if (!tabScroll) scrollSpacer.style.height = '0px';
      const measurements = sizeScrollSpacer(elements[0], elements[elements.length - 1]);

      // JC-EVO 10/06/2026 (RC8): preserve the existing aligned-position restore after resize.
      if (wasAligned) {
        scrollToY(measurements.targetY);
      }
    }

    let spacerResizeTimeout = null;
    listen(window, 'resize', () => {
      if (spacerResizeTimeout) clearTimeout(spacerResizeTimeout);
      spacerResizeTimeout = setTimeout(refreshScrollSpacer, 150);
    });
    
    // Handle URL hash for direct linking
    const hash = window.location.hash.slice(1);
    if (hash) {
      tabs.forEach(tab => {
        const classes = tab.dataset.tabClasses || '';
        if (classes.split(',').map(c => c.trim()).includes(hash)) {
          if (tab.style.display !== 'none') {
            tab.click();
          }
        }
      });
    }
    
    // Observe DOM changes to update tab visibility when sections are dynamically hidden.
    // JC-EVO 09/28/2026 (speed): re-run only for style changes that can change the answer: any style change on the nodes
    // this check reads (section wrappers, tab content, accordion items), or an inline display/visibility change anywhere.
    // Carousels, apps and video players rewrite transforms and sizes many times a second; before, every one of those
    // re-ran the check and forced full style recalculations (250-340 ms long tasks on a mid-range phone, Lighthouse 09/28).
    const watchSelector = ['.shopify-section', '.ptc__tab', 'details[class*="tab-name-"]', '.accordion__item', '.collapsible-tab']
      .concat(getAllTargetClasses().map(cls => '.' + CSS.escape(cls))).join(',');
    const displayState = (style) => {
      const s = style || '';
      const d = s.match(/(?:^|;)\s*display\s*:\s*([^;]+)/i);
      const v = s.match(/(?:^|;)\s*visibility\s*:\s*([^;]+)/i);
      return (d ? d[1].trim() : '') + '|' + (v ? v[1].trim() : '');
    };
    // JC-EVO 09/30/2026 N03 (core fork, speed): each pass forces a style recalculation of every hidden tab panel. A style record now
    // re-runs it only on a tab target, inside one, or on a node containing one (its section wrapper and the ancestors above it); the
    // three scheduled passes above are unchanged. Dropped: records on other nodes (hero CSS variables, app popups, carousels) and
    // this script's own tab-button / tab-bar writes. Basis (audited 09/30/2026 on the rendered product pages, apps active): no
    // display/visibility rule keys a tab target off the inline style of a node that neither contains nor sits inside one.
    const targetSelector = getAllTargetClasses().map(cls => '.' + CSS.escape(cls)).join(',');
    const nearTarget = (t) => !!targetSelector && (!!t.closest(targetSelector) || !!t.querySelector(targetSelector));
    const canChangeVisibility = (m) => {
      const t = m.target;
      if (t === scrollSpacer || t.nodeType !== 1) return false;
      return (t.matches(watchSelector) || displayState(m.oldValue) !== displayState(t.getAttribute('style'))) && nearTarget(t);
    };
    let updateTimeout = null;
    const observer = new MutationObserver((mutations) => {
      // Ignore our own scroll spacer resizing itself, and style changes that cannot change which tabs have content
      if (!mutations.some(canChangeVisibility)) return;

      // Debounce updates to prevent too many recalculations
      if (updateTimeout) clearTimeout(updateTimeout);
      updateTimeout = setTimeout(() => {
        if (navContainer.isConnected) updateTabVisibility(); // JC-EVO 10/06/2026 (RC8): detached callback.
      }, 100);
    });
    
    // Observe the document body for style changes on shopify-section elements
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style'],
      attributeOldValue: true,
      subtree: true
    });
    
    // Sticky boundary detection - stop sticky when past tab content
    const stickyEnabled = cfg.sticky_nav;
    const stickyEndBuffer = cfg.sticky_end_buffer;
    
    if (stickyEnabled) {
      const sectionWrapper = navContainer.closest('.shopify-section');
      
      // JC-EVO 09/30/2026 N06 (core fork, speed): same boundary, fewer reads per scroll frame. Targets that share a section are
      // measured once, and the scroll position is read once: after the first rect the layout is clean, so it cannot move between
      // these synchronous reads. Before, every target re-resolved the scroller (a computed-style read) and re-read scrollTop.
      function getTabContentBottom() {
        const boxes = new Set();
        getAllTargetClasses().forEach(cls => {
          document.querySelectorAll('.' + cls).forEach(el => boxes.add(el.closest('.shopify-section') || el));
        });
        let maxBottom = 0;
        let scrollTop = null;
        boxes.forEach(box => {
          const rect = box.getBoundingClientRect();
          if (scrollTop === null) scrollTop = getScrollTop();
          const absoluteBottom = scrollTop + rect.bottom;
          if (absoluteBottom > maxBottom) maxBottom = absoluteBottom;
        });
        return maxBottom;
      }
      
      function updateStickyState() {
        if (!sectionWrapper) return;
        
        const tabContentBottom = getTabContentBottom();
        const navHeight = navContainer.offsetHeight;
        const stickyOffset = window.innerWidth < 750 
          ? cfg.sticky_offset_mobile
          : cfg.sticky_offset;
        
        // Calculate the point where sticky should stop
        // (tab content bottom - nav height - sticky offset - buffer)
        const stickyEndPoint = tabContentBottom - navHeight - stickyOffset - stickyEndBuffer;
        
        if (getScrollTop() > stickyEndPoint) {
          sectionWrapper.classList.add('sticky-disabled');
        } else {
          sectionWrapper.classList.remove('sticky-disabled');
        }
      }
      
      // Throttle scroll handler for performance
      let scrollTicking = false;
      onScroll(() => {
        if (!scrollTicking) {
          requestAnimationFrame(() => {
            if (navContainer.isConnected) updateStickyState(); // JC-EVO 10/06/2026 (RC8): detached frame.
            scrollTicking = false;
          });
          scrollTicking = true;
        }
      });
      
      // Initial check after content is loaded
      listen(window, 'load', () => {
        setTimeout(() => { if (navContainer.isConnected) updateStickyState(); }, 200); // JC-EVO 10/06/2026 (RC8): detached load.
      });
      
      // Recalculate on resize
      listen(window, 'resize', () => {
        setTimeout(() => { if (navContainer.isConnected) updateStickyState(); }, 100); // JC-EVO 10/06/2026 (RC8): detached resize.
      });
    }
    }
    
    function initAll(scope) {
    (scope || document).querySelectorAll('[data-pt-config]').forEach(function (el) {
      if (el.dataset.ptReady) return;
      el.dataset.ptReady = '1';
      var cfg = {};
      try { cfg = JSON.parse(el.getAttribute('data-pt-config')); } catch (e) { return; }
      initProductTabs(el, cfg);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  // theme editor: re-init a re-rendered section
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
